import styles from "./MoveModal.module.css";
import PropTypes from "prop-types";
import RadioButtonList from "../RadioButtonList";
import Button from "shared/Button";
import Checkbox from "../Checkbox";
import ObjectSelect from "../ObjectSelect";
import { useState, useEffect } from "react";
import { Dashboard } from "ManagementTeam/DashboardPage/useDashboard";
import moment from "moment-timezone";
import Modal from "../Modal";
/**
 *
 * Modal when adding an agenda item on the agenda page
 *
 */

export function MoveModal({ isOpen, onClose, onMove, onDuplicate }) {
  const { getAvailableMeetings } = Dashboard.useContainer();
  const [radioListValue, setRadioListValue] = useState("Move To");
  const [moveToLocation, setMoveToLocation] = useState("Management Team");

  const [meetings, setMeetings] = useState([]);

  const [meetingDateOptions, setMeetingDateOptions] = useState([]);
  const [dateSelect, setDateSelect] = useState(null);

  const initActionOptions = () => {
    let options = [];
    if (onMove) options = [...options, "Move To"];

    if (onDuplicate) options = [...options, "Duplicate To"];

    return options;
  };
  const getNameOfTwoDaysMeeting = (mArray) => {
    const day1 = mArray[0].split(/[\s,]+/);
    const day2 = mArray[1].split(/[\s,]+/);
    if (day1[2] === day2[2]) {
      if (day1[0] === day2[0])
        return `${day1[0]} ${day1[1]} & ${day2[1]}, ${day1[2]}`;
      else {
        return `${day1[0].substring(0, 3)} ${day1[1]} & ${day2[0].substring(
          0,
          3
        )} ${day2[1]}, ${day1[2]}`;
      }
    } else {
      return `${day1[0].substring(0, 3)} ${day1[1]}, ${
        day1[2]
      } & ${day2[0].substring(0, 3)} ${day2[1]}, ${day2[2]}`;
    }
  };
  const optionMoveDuplicate = initActionOptions();

  useEffect(() => {
    getAvailableMeetings().then((a) => {
      setMeetings(a);
    });
  }, []);

  const zeroPad = (num, places) => String(num).padStart(places, "0");
  useEffect(() => {
    if (meetings && meetings.length > 0 && moveToLocation) {
      const months = {
        January: "01",
        February: "02",
        March: "03",
        April: "04",
        May: "05",
        June: "06",
        July: "07",
        August: "08",
        September: "09",
        October: "10",
        November: "11",
        December: "12",
      };

      var options = meetings.map((meeting) => {
        // format options string
        let dateString =
          meeting.dates.length > 0
            ? meeting.dates.map((date) =>
                moment.utc(date.startsOn).format("MMMM DD, YYYY")
              )
            : [];

        return {
          id: meeting.id,
          meetingType: meeting.meetingType,
          option:
            dateString.length === 2
              ? getNameOfTwoDaysMeeting(dateString)
              : dateString[0],
          date: new Date(meeting.dates[0].startsOn),
        };
      });

      options = options.sort((a, b) => a.date - b.date);
      //filter down to location
      options = options.filter((a) =>
        moveToLocation == "Management Team"
          ? a.meetingType == "MT"
          : a.meetingType == "EC"
      );
      setMeetingDateOptions(options);

      if (options.length > 0) {
        setDateSelect(options[0]);
      }
    }
  }, [meetings, moveToLocation]);

  return (
    <Modal
      isOpen={isOpen}
      className={styles.modal}
      children={
        <div className={styles.container}>
          <div className={styles.modalContainer}>
            <div className={styles.modalHeader}>
              <Button
                className={styles.cancelButton}
                children="Cancel"
                onClick={() => onClose()}
              />
              <Button
                className={styles.moveButton}
                children={radioListValue == "Move To" ? "Move" : "Duplicate"}
                onClick={
                  radioListValue == "Move To"
                    ? () => onMove(dateSelect)
                    : () => onDuplicate(dateSelect)
                }
              />
            </div>
            <div className={styles.modalBody}>
              <div>Agenda Location</div>

              {/* <Checkbox
              checked={mt}
              onChange={() => setMt(!mt)}
              className={styles.checkbox}
            />
            <div className={styles.checkboxLabel}>Management Team</div>

            <Checkbox
              checked={ec}
              onChange={() => setEc(!ec)}
              className={styles.checkbox}
            />
            <div className={styles.checkboxLabel}>Executive Committee</div> */}

              <div className={styles.radioList}>
                <RadioButtonList
                  selectedOption={moveToLocation}
                  onClick={setMoveToLocation}
                  options={["Management Team", "Executive Committee"]}
                  direction="horizontal"
                  customClassName={styles.radioButton}
                />
              </div>

              <div className={styles.radioList}>
                <RadioButtonList
                  selectedOption={radioListValue}
                  onClick={setRadioListValue}
                  options={optionMoveDuplicate}
                  direction="horizontal"
                  customClassName={styles.radioButton}
                />
              </div>

              {dateSelect && (
                <div className={styles.selectContainer}>
                  <ObjectSelect
                    options={meetingDateOptions}
                    onChange={(e) => {
                      setDateSelect(
                        meetingDateOptions.filter((m) => m.id === e)[0]
                      );
                    }}
                    selectedValue={dateSelect.option}
                    placeholder={dateSelect.option}
                    selectedOption={dateSelect}
                    className={styles.select}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      }
    />
  );
}

MoveModal.propTypes = {
  meetings: PropTypes.arrayOf(PropTypes.object),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onMove: PropTypes.func,
  onDuplicate: PropTypes.func,
};
